module.exports = __webpack_public_path__ + "static/media/Silver-2013-Pinot-Noir.732ac530.jpg";